export default __webpack_public_path__ + "static/media/riverside-lanes-burger.f72dc544.jpg";